import { Box, Button } from "@mui/material";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useApiMutation } from "src/hooks/useApiMutation";
import VisitorMoneyReceiptForm from "./VisitorMoneyReceiptForm";
import type { ISingleInvoiceVisitor } from "../type/visitorType";

interface IProps {
	handleClose: () => void;
	invoiceDetails?: ISingleInvoiceVisitor;
}
const CreateVisitorMoneyReceipt = ({ handleClose, invoiceDetails }: IProps) => {
	const {
		mutate: CreateVisitorMoneyReceipt,
		isPending,
		isSuccess,
	} = useApiMutation<any, void>({
		method: "POST",
		endPoint: "/api/admin/visitor/money-receipt",
		invalidateQueries: ["visitorSingleInvoice", "money-receipt"],
	});
	const { control, register, handleSubmit, watch } = useForm<any>({
		defaultValues: {
			payment_date: dayjs().format("YYYY-MM-DD"),
		},
	});
	const onSubmit = (formData: any) => {
		if (invoiceDetails?.id && invoiceDetails?.visitor_id) {
			formData.visitor_id = invoiceDetails?.visitor_id;
			formData.invoice_id = invoiceDetails?.id;
		}
		CreateVisitorMoneyReceipt(formData);
	};

	useEffect(() => {
		if (isSuccess) {
			handleClose();
		}
	}, [isSuccess]);

	return (
		<Box component='form' onSubmit={handleSubmit(onSubmit)} sx={{ p: 2 }}>
			<VisitorMoneyReceiptForm
				register={register}
				watch={watch}
				control={control}
				invoiceDetails={invoiceDetails}
			/>

			<Button
				type='submit'
				fullWidth
				variant='contained'
				sx={{ mt: 3 }}
				disabled={isPending}
			>
				Create Money Receipt
			</Button>
		</Box>
	);
};

export default CreateVisitorMoneyReceipt;
